"use client";

import { useEffect } from "react";

export default function PWARegister() {
  useEffect(() => {
    // Silent Background Service Worker Registration for PWA caching & push notifications
    if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register("/sw.js")
          .catch((err) => {
            console.error("ServiceWorker registration failed: ", err);
          });
      });
    }
  }, []);

  return null;
}
